import { atom } from 'recoil';

export const showHeaderCompetenceAtom = atom({ key: 'showHeaderCompetenceAtom', default: false });
